export default __webpack_public_path__ + "static/reviewer-image-1-1eae41fb4c230364adc17e90580f1401.png";